import React from 'react';
import { Typography, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Footer from '../Components/Footer';
const { Title } = Typography;

const PrivacyScreen = () => {
  const gradientTextStyle = {
    backgroundImage: 'linear-gradient(-45deg, #7c3aed, #a855f7, #d946ef)',
    backgroundSize: '200% 200%',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    animation: 'gradient 5s ease infinite',
    fontWeight: '900',
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-gray-50">
      <div className="absolute top-4 left-4 z-10">
        <Link to="/">
          <Button 
            type="text"
            icon={<ArrowLeftOutlined />}
            className="flex items-center text-purple-700 hover:text-purple-900 font-semibold text-lg hover:bg-purple-50 rounded-full px-6 py-2 h-auto"
          >
            Back to Home
          </Button>
        </Link>
      </div>

      <div className="absolute inset-0 bg-[conic-gradient(at_top_right,_var(--tw-gradient-stops))] from-indigo-200/80 via-purple-100/80 to-pink-100/80 -z-10" />
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gradient-to-bl from-purple-300/30 to-blue-300/30 rounded-full blur-3xl -z-10 animate-pulse" />
      <div className="absolute bottom-0 left-0 w-2/3 h-2/3 bg-gradient-to-tr from-pink-200/30 to-indigo-300/30 rounded-full blur-3xl -z-10 animate-pulse" />

      <div className="container mx-auto px-4 py-12 pt-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-block mb-4 px-6 py-2 rounded-full bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 text-sm font-semibold shadow-lg">
              🔒 Privacy Policy
            </div>
            <h1 className="text-6xl font-black mb-6" style={gradientTextStyle}>
              Our Commitment to Your Privacy
            </h1>
            <p className="text-xl text-gray-600">
              Last updated on <strong className="text-purple-700">13/02/2025</strong>
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-xl border border-white/50 p-8 md:p-12 space-y-8">
            <div className="prose prose-lg max-w-none">
              <p>Our Privacy Policy was last updated on <strong>13/02/2025</strong>.</p>

              <p>At <strong>CarouselPost.in</strong>, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by <strong>CarouselPost.in</strong> and how we use it.</p>

              <p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us at <a href="mailto:shubhankardev8@gmail.com" className="text-blue-600 hover:text-blue-800">shubhankardev8@gmail.com</a>.</p>

              <p>This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collected on <a href="www.carouselpost.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">www.carouselpost.in</a>. This policy is not applicable to any information collected offline or via channels other than this website.</p>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Consent</h2>
                <p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Information We Collect</h2>
                <p>The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information. This policy has been generated by <a href="https://dodopayments.com" className="text-blue-600 hover:text-blue-800">dodopayments.com</a>.</p>

                <p>If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.</p>

                <p>When you register for an account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.</p>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>How We Use Your Information</h2>
                <p>We use the information we collect in various ways, including to:</p>

                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide, operate, and maintain our website.</li>
                  <li>Improve, personalize, and expand our website.</li>
                  <li>Understand and analyze how you use our website.</li>
                  <li>Develop new products, services, features, and functionality.</li>
                  <li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes.</li>
                  <li>Send you emails.</li>
                  <li>Find and prevent fraud.</li>
                </ul>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Log Files</h2>
                <p><strong>CarouselPost.in</strong> follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this as part of hosting services' analytics.</p>

                <p>The information collected by log files includes internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.</p>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Cookies and Web Beacons</h2>
                <p>Like any other website, <strong>CarouselPost.in</strong> uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited.</p>

                <p>The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.</p>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Advertising Partners Privacy Policies</h2>
                <p>Third-party ad servers or ad networks use technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on <strong>CarouselPost.in</strong>, which are sent directly to users' browsers. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.</p>

                <p>Note that <strong>CarouselPost.in</strong> has no access to or control over these cookies that are used by third-party advertisers.</p>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Third Party Privacy Policies</h2>
                <p><strong>CarouselPost.in</strong>'s Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.</p>

                <p>You can choose to disable cookies through your individual browser options. This is recommended by dodopayments.com. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.</p>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>CCPA Privacy Rights (Do Not Sell My Personal Information)</h2>
                <p>Under the CCPA, among other rights, California consumers have the right to:</p>

                <ul className="list-disc pl-6 space-y-2">
                  <li>Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.</li>
                  <li>Request that a business delete any personal data about the consumer that a business has collected.</li>
                  <li>Request that a business that sells a consumer's personal data, not sell the consumer's personal data.</li>
                </ul>

                <p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>GDPR Data Protection Rights</h2>
                <p>We want to ensure you are fully aware of all of your data protection rights. Every user is entitled to the following:</p>

                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>The right to access:</strong> You have the right to request copies of your personal data. We may charge you a small fee for this service.</li>
                  <li><strong>The right to rectification:</strong> You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.</li>
                  <li><strong>The right to erasure:</strong> You have the right to request that we erase your personal data, under certain conditions.</li>
                  <li><strong>The right to restrict processing:</strong> You have the right to request that we restrict the processing of your personal data, under certain conditions.</li>
                  <li><strong>The right to object to processing:</strong> You have the right to object to our processing of your personal data, under certain conditions.</li>
                  <li><strong>The right to data portability:</strong> You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</li>
                </ul>

                <p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>
              </div>

              <div className="mt-12">
                <h2 className="text-4xl font-black mb-6" style={gradientTextStyle}>Children's Information</h2>
                <p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity. These guidelines have been generated by dodopayments.com.</p>

                <p><strong>CarouselPost.in</strong> does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyScreen;